import HeaderComponent from "../Component/HeaderComponent"
import SidebarComponent from "../Component/SidebarComponent"
import cpuIcon from '../Assets/icons/cpuIcon.svg'
import qrCodeIcon from '../Assets/icons/qrCodeIcon.svg'
import fingerPrintIcon from '../Assets/icons/fingerPrintIcon.svg'
import paperIcon from '../Assets/icons/paperICon.svg'
import passWordIcon from '../Assets/icons/passwordIcon.svg'
import './ConfiguracoesPage.css'
import { useEffect, useState } from "react"
import GoogleAuthenticatorComponent from "../Component/googleAuthenticatorComponent"
import axiosInstance from "../Services/Api"
const ConfiguracoesPage = () => {
    const [pinActive, setPinActive] = useState(false)
    const [twofaActive, setTwofaActive] = useState(false)
    const [documentationActive, setDocumentationActive] = useState(false)
    const [passswordActive, setPasswordActive] = useState(false)
    const [sidebarOpen, setSiidebarOpen] = useState(false)
    const [AuthenticatorOpen, setAuthenticatorOpen] = useState(false)
    const [UserActive, setUserActive] = useState(false)
    const setSidebarOpen = (bool) => {
        window.localStorage.setItem('sidebarIsOpen', JSON.stringify(bool))
        setSiidebarOpen(bool)
    }
    useEffect(() => {
        const localSidebarStorage = JSON.parse(window.localStorage.getItem('sidebarIsOpen'))
        setSiidebarOpen(localSidebarStorage)
        const userData = async () => {
            try {
                const response = await axiosInstance.get('/api/getUserData')
                setUserActive(response.data.status)
                setDocumentationActive(response.data.documentation)
                setTwofaActive(response.data.twoFaStatus)
            } catch (e) {
                if (e.status === 401) {
                    window.localStorage.removeItem('token')
                    window.location.reload()
                }
            }
        }
        userData()
    }, [])

    const OpenAutheticator = () => {
        setAuthenticatorOpen(!AuthenticatorOpen)
    }
    return (
        <div className={`w-ful flex md:h-screen ${AuthenticatorOpen? 'h-screen': ''}  bg-[#171717]`}>
            <SidebarComponent sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className={`${sidebarOpen?'md:ml-[250px]' : 'md:ml-[100px]'}  text-white w-full  md:mt-8`}>
                <HeaderComponent setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} title={'Bem vindo(a) a dxpay !'} subTitle={'Seja bem-vindo ao painel de controle da sua empresa'} />
                {UserActive === 0 ? <p className="px-4  mt-4 text-[red]">Para usar o gateway voce precisa ter autenticação de 2 fatores ativa e documentação aprovada!</p> : ""}
                <div className={`${AuthenticatorOpen ? 'hidden' : ''} w-full md:static relative z-[9999] md:pb-0 pb-[20px] flex justify-center px-4`}>
                    <div className="w-full gap-5 mt-8 grid  md:grid-cols-3">
                        {/* <div className="pt-0 linear-geadient rounded-[14px] px-[1px] pb-[2px] h-[257px] md:h-full">
                            <div className="w-full gap-4 flex flex-col items-center p-8 rounded-[14px] bg-[#1D1D1D] h-full relative">
                                <img src={cpuIcon} />
                                <h1 className="">Pin de transação</h1>
                                <p className="text-[13px] text-[#AEB9E1] mb-[50px] text-center">Aumente a segurança de sua conta com uma etapa a mais de verificação a cada transação que for realizada.</p>
                                <button onClick={() => { setPinActiveFunction(!pinActive) }} className="flex bg-[#478DF8] gap-1 items-center p-1 text-[12px] px-2 rounded-[10px] absolute bottom-[20px]">
                                    <img src={qrCodeIcon} />
                                    {pinActive ? 'Ativo' : 'Ativar'}
                                </button>
                            </div>
                        </div> */}
                        <div className="pt-0 linear-geadient rounded-[14px] px-[1px] pb-[2px] h-[257px] md:h-full">
                            <div className="w-full gap-4 flex flex-col items-center p-8 rounded-[14px] bg-[#1D1D1D] h-full relative">
                                <img src={fingerPrintIcon} />
                                <h1 className="">Autenticação 2F</h1>
                                <p className="text-[13px] mb-[20px] text-[#AEB9E1] text-center">Aumente a segurança de sua conta com uma etapa a mais de verificação a cada transação que for realizada.</p>
                                {twofaActive ? <button className="flex bg-[#478DF8] gap-1 items-center p-1 text-[12px] px-2 rounded-[10px] absolute bottom-[20px]">
                                    <img src={qrCodeIcon} />
                                    ativa
                                </button> :
                                    <button onClick={OpenAutheticator} className="flex bg-[#478DF8] gap-1 items-center p-1 text-[12px] px-2 rounded-[10px] absolute bottom-[20px]">
                                        <img src={qrCodeIcon} />
                                        ativar
                                    </button>}
                            </div>
                        </div>
                        <div className="pt-0 linear-geadient rounded-[14px] px-[1px] pb-[2px] h-[257px] md:h-full">
                            <div className="w-full gap-4 flex flex-col items-center p-8 rounded-[14px] bg-[#1D1D1D] h-full relative">
                                <img src={paperIcon} />
                                <h1 className="">Documentação</h1>
                                <p className="text-[13px] text-[#AEB9E1] text-center mb-[20px]">Para garantir maior segurança e acessar nossos serviços, é necessário enviar sua documentação e aguardar a aprovação no sistema.</p>
                                {documentationActive ? <button className="flex bg-[#478DF8] gap-1 items-center p-1 text-[12px] px-2 rounded-[10px] absolute bottom-[20px]">
                                    <img src={qrCodeIcon} />
                                  {UserActive ?'Aprovada' :'Análise'}

                                </button> :
                                    <button onClick={() => { window.location.href = '/#/profile' }} className="flex bg-[#478DF8] gap-1 items-center p-1 text-[12px] px-2 rounded-[10px] absolute bottom-[20px]">
                                        <img src={qrCodeIcon} />
                                        Enviar

                                    </button>
                                }
                            </div>
                        </div>
                        <div className="pt-0 linear-geadient rounded-[14px] px-[1px] pb-[2px] h-[257px] md:h-full">
                            <div className="w-full gap-4 flex flex-col items-center p-8 rounded-[14px] bg-[#1D1D1D] h-full relative">
                                <img src={passWordIcon} />
                                <h1 className="">Senha</h1>
                                <p className="text-[13px] text-[#AEB9E1] text-center mb-[20px]">Garanta a segurança da sua conta mantendo sua senha sempre atualizada.</p>
                                <button onClick={() => { window.location.href = '/#/profile' }} className="flex bg-[#478DF8] gap-1 items-center p-1 text-[12px] px-2 rounded-[10px] absolute bottom-[20px]">
                                    <img src={qrCodeIcon} />
                                    atualizar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {AuthenticatorOpen && <GoogleAuthenticatorComponent setTwoFactorActive={setTwofaActive} setAuthenticationOpen={setAuthenticatorOpen} />}
            </div>
        </div>
    )
}

export default ConfiguracoesPage